// V1-COMPAT: the "V1MediaOutletsIndex" mount (react18_mount.js) -- V2's media outlets index body
// on V1's /publications page.
//
// V2 renders this panel inside its own Media Database page (source_directory/SourceDirectory.jsx),
// which draws the heading and tab bar above it and holds the toolbar state on the panel's behalf.
// V1 draws that heading and those tabs itself in ERB, so only the panel is wanted here, and this
// host supplies the state SourceDirectory would have. Nothing about the copied panel changes.
//
// Saved groups are left out of V1 entirely. SourceDirectory wraps its panels in a
// SavedGroupsProvider and owns the panel that manages the groups; without both, a bookmark could
// be set but never reviewed, and the Saved filter would match nothing. So this host mounts no
// provider -- which is what makes each card's SavedGroupsBookmark render nothing -- and turns off
// the two toolbar controls that would otherwise be dead: Saved and My Groups.
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import withV2Identity from './with_v2_identity';
import MediaOutletsSearch from '../media_outlets/MediaOutletsSearch';

function MediaOutletsIndex({ algoliaAppId, algoliaSearchKey, indexName }) {
  const [viewMode, setViewMode] = useState('grid');
  const [showFilters, setShowFilters] = useState(false);

  return (
    <MediaOutletsSearch
      algoliaAppId={algoliaAppId}
      algoliaSearchKey={algoliaSearchKey}
      indexName={indexName}
      viewMode={viewMode}
      onViewModeChange={setViewMode}
      showFilters={showFilters}
      onToggleFilters={() => setShowFilters((open) => !open)}
      // Saved is off, so the filter it drives is permanently inert; the toolbar still requires a
      // handler for the control it is not rendering.
      savedOnly={false}
      onToggleSavedOnly={() => {}}
      showSavedToggle={false}
      showMyGroupsButton={false}
    />
  );
}

MediaOutletsIndex.propTypes = {
  algoliaAppId: PropTypes.string.isRequired,
  algoliaSearchKey: PropTypes.string.isRequired,
  indexName: PropTypes.string.isRequired,
};

const V1MediaOutletsIndex = withV2Identity(MediaOutletsIndex);

export default V1MediaOutletsIndex;
